import React from "react";
import { Switch, Route } from "react-router-dom";

import Authorization from "../../components/Authorization";
import OrderArchiveHistoryRouter from "./OrderArchiveHistory";

import CompanyRouter from "./Company";
import HolidayScheduleRouter from "./HolidaySchedule";
import SystemCodeRouter from "./SystemCodes";
import UserRouter from "./Users";
import GroupRouter from "./Groups";

/**
 * ROLES
 * ADMIN, BILL, CUSTS, DISP, DRIVER, FLEET, MECH, MGMNT, PAY, SCH
 */

// const Admin = Authorization(["ADMIN"]);
// const Payroll = Authorization(["ADMIN", "HR"]);
// const Management = Authorization(["ADMIN", "MGMNT"]);
// const PayMgmnt = Authorization(["ADMIN", "HR", "MGMNT"]);
const OrderArchive = Authorization(["ADMIN", "FIN"]);

const SystemAdministrationRouter = () => (
  <Switch>
    <Route path="/admin/users">
      <UserRouter />
    </Route>
    <Route path="/admin/company">
      <CompanyRouter />
    </Route>
    <Route path="/admin/holidays">
      <HolidayScheduleRouter />
    </Route>
    <Route path="/admin/codes">
      <SystemCodeRouter />
    </Route>
    <Route path="/admin/groups">
      <GroupRouter />
    </Route>
    <Route path="/admin/order-archive-history">
      {OrderArchive(OrderArchiveHistoryRouter)}
    </Route>
  </Switch>
);

export default SystemAdministrationRouter;
